import React from 'react'

import { Button, Card, Dropdown, Menu, Tag } from 'antd'

const CourseImage = ({ image, backgroundColor }) => {
  if (!image)
    return (
      <div style={{ backgroundColor: `${backgroundColor}`, height: 180 }}></div>
    )

  return (
    <img
      style={{
        height: '180px',
        objectFit: 'cover',
        objectPosition: 'top'
      }}
      alt="course img"
      src={image}
    />
  )
}

const CardContent = (props) => {
  const {
    description,
    enrolled,
    onEnroll,
    onUnenroll,
    loadingEnroll,
    disableEnroll,
    category,
  } = props

  const isMandatory =
  category?.categoryName?.toLowerCase() === 'mandatory courses'

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <div
        style={{
          height: '90px',
          overflow: 'auto',
          textOverflow: 'ellipsis',
          scrollbarWidth: 'none',
          msOverflowStyle: 'none'
        }}
      >
        {description}
      </div>

      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <div style={{ margin: '20px 2px 5px 0px', alignSelf: 'flex-start' }}>
          <Tag
            color={category?.backgroundColor}
            style={{
              fontSize: '14px',
              padding: '4px 10px',
              borderRadius: '12px',
              fontWeight: 500,
            }}
          >
            {category?.categoryName || 'Uncategorized'}
          </Tag>
        </div>

        <div
          onClick={(event) => {
            event.stopPropagation()
          }}
          style={{
            margin: '20px 2px 5px 0px',
            alignSelf: 'flex-end'
          }}
        >
          {!disableEnroll && !isMandatory && (
            <>
              {!enrolled && (
                <Button loading={loadingEnroll} onClick={() => onEnroll()}>
                  Enroll
                </Button>
              )}

              {enrolled && (
                <Button loading={loadingEnroll} onClick={() => onUnenroll()}>
                  Unenroll
                </Button>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  )
}

const CourseCard = (props) => {
  const {
    course,
    onClick,
    handleEnroll,
    handleUnenroll,
    removeCourse,
    disableEnroll,
    unarchive,
    isArchivePage,
  } = props

  if (!course || !course.name) {
    return null
  }

  const { enrolled, privilege } = course
  const loadingEnroll = course.loadingEnroll

  const optionMenu = (
    <Menu>
      {isArchivePage &&
        (privilege === 'instructor' || privilege === 'admin') && (
          <Menu.Item onClick={unarchive}>Unarchive Course</Menu.Item>
        )}
      {(privilege === 'instructor' || privilege === 'admin') && (
        <Menu.Item onClick={removeCourse} danger>
          Delete Course
        </Menu.Item>
      )}
    </Menu>
  )

  return (
    <Card
      hoverable
      bordered={false}
      cover={
        <CourseImage
          image={course.image}
          backgroundColor={course.backgroundColor}
        />
      }
      onClick={onClick}
    >
      <Card.Meta
        title={
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              minHeight: '32px'
            }}
          >
            {course.name}
            <span
              onClick={(event) => {
                event.stopPropagation()
              }}
            >
              {((enrolled && !disableEnroll && !isArchivePage) ||
                (isArchivePage && course && course.name)) && (
                <Dropdown.Button
                  placement="bottomCenter"
                  type="text"
                  overlay={optionMenu}
                ></Dropdown.Button>
              )}
            </span>
          </div>
        }
        description={
          <CardContent
            loadingEnroll={loadingEnroll}
            description={course.description}
            enrolled={enrolled}
            onEnroll={handleEnroll}
            onUnenroll={handleUnenroll}
            disableEnroll={disableEnroll}
            category={course?.category}
          />
        }
      />
    </Card>
  )
}

export default CourseCard
